<template>
  <div class="mt-3">
    <InputText
      v-model="filter.search"
      type="text"
      faIcon="search"
      className="my-3 bg-second w-50"
      placeholder="ค้นหาสินค้า"
      @onClickIcon="onSearch"
      textField="telephone"
      @onEnter="onSearch"
    />
    <b-table
      striped
      hover
      :busy="isBusy"
      :items="items"
      :fields="type == 3 ? fieldsProduct : fields"
      show-empty
      empty-text="No matching records found"
    >
      <template v-slot:cell(image_url)="{ item }">
        <img :src="item.image_url" class="img-size" v-if="item.image_url" />
        <img
          v-else
          src="@/assets/images/noimg.png"
          alt="no-image-product"
          class="img-size"
        />
      </template>

      <template v-slot:cell(count_stock)="data">
        {{ data.item.count_stock }}
      </template>
      <template v-slot:cell(product_model_code)="data">
        {{ data.item.product_model_code || "-" }}
      </template>
      <template v-slot:cell(product_sub_model_code)="data">
        {{ data.item.product_sub_model_code || "-" }}
      </template>
      <template v-slot:cell(product_sub_model_name)="data">
        {{ data.item.product_sub_model_name || "-" }}
      </template>
      <template v-slot:cell(document_no)="data">
        {{ data.item.document_no || "-" }}
      </template>
      <template v-slot:cell(product_price)="data">
        {{ data.item.product_price | numeral("0,0.00") }}
      </template>
      <template v-slot:cell(serial_name)="data">
        {{ data.item.serial_name || "-" }}
      </template>
      <template v-slot:cell(stock_surplus)="data">
        <span class="text-primary"> {{ data.item.stock_surplus || "-" }}</span>
      </template>
      <template v-slot:cell(stock_deficit)="data">
        <span class="text-danger"> {{ data.item.stock_deficit || "-" }}</span>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-black my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="ml-2">Loading...</strong>
        </div>
      </template>
    </b-table>
    <Pagination
      @handleChangeTake="handleChangeTake"
      :pageOptions="pageOptions"
      :filter="filter"
      :rows="rows"
      @pagination="pagination"
    />
    <FooterAction backAction hideSubmit @routePath="$emit('close')">
      ></FooterAction
    >
  </div>
</template>

<script>
import FooterAction from "@/components/FooterAction";
export default {
  components: { FooterAction },
  props: {
    type: {
      required: false,
      default: 1,
    },
    invoice: {
      required: false,
    },
  },
  data() {
    return {
      filter: {
        search: "",
        inventory_check_id: Number(this.$route.params.id),
        page: 1,
        take: 10,
      },
      fields: [
        { label: "ชนิด", key: "product_model_code" },
        { label: "หมวด", key: "product_sub_model_code" },
        { label: "ชื่อหมวด", key: "product_sub_model_name" },

        {
          label: "จำนวน",
          key: "inventory_stock",
        },
        {
          label: "จำนวนที่นับ",
          key: "count_stock",
        },
        {
          label: "ขาด",
          key: "stock_deficit",
        },
        {
          label: "เกิน",
          key: "stock_surplus",
        },
      ],
      fieldsProduct: [
        { label: "รูป", key: "image_url" },
        { label: "Barcode", key: "barcode" },
        { label: "Serial", key: "serial_name" },

        {
          label: "ราคา",
          key: "product_price",
        },
        {
          label: "เลขเอกสาร",
          key: "document_no",
        },
        {
          label: "ขาด",
          key: "stock_deficit",
        },
        {
          label: "เกิน",
          key: "stock_surplus",
        },
      ],
      items: [],
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      rows: 0,
      isBusy: false,
    };
  },
  created() {
    this.getReport();
  },
  watch: {
    type(value) {
      this.filter = {
        search: "",
        inventory_check_id: Number(this.$route.params.id),
        page: 1,
        take: 10,
      };
      this.getReport();
    },
  },
  methods: {
    async getReport(type) {
      if (this.type == 3) {
        const res = await this.axios.post(
          `${this.$baseUrl}/inventorycheck/report/get-check-product`,
          this.filter
        );
        this.items = res.detail.data;
        this.rows = res.detail.total;
      } else {
        const res = await this.axios.post(
          `${this.$baseUrl}/inventorycheck/report/get-check-product-group`,
          this.filter
        );
        this.items = res.detail.data;
        this.rows = res.detail.total;
      }
    },
    async exportFile(type) {
      try {
        await this.$store.dispatch("setMainLoading", true);

        let res = null;
        if (this.type == 3) {
          res = await this.axios.post(
            `${this.$baseUrl}/inventorycheck/report/get-check-product/export`,
            this.filter,
            {
              responseType: "blob",
            }
          );
        } else {
          res = await this.axios.post(
            `${this.$baseUrl}/inventorycheck/report/get-check-product-group/export`,
            this.filter,
            {
              responseType: "blob",
            }
          );
        }

        const blob = new Blob([res]);

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `inventoy-check-${this.invoice}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        await this.$store.dispatch("setMainLoading", false);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        await this.$store.dispatch("setMainLoading", false);
        console.error("Error downloading PDF:", error);
      }
    },
    pagination(value) {
      this.filter.page = value;
      this.getReport(this.type);
    },
    handleChangeTake(value) {
      this.filter.page = 1;
      this.filter.take = value;
      this.getReport(this.type);
    },
    onSearch() {
      this.getReport();
    },
  },
};
</script>

<style></style>
